function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.046 16.516l.716.716a.506.506 0 00.716 0l7.874-7.874a.506.506 0 000-.716L9.478.768a.506.506 0 00-.716 0l-.716.716a.506.506 0 000 .715l5.786 5.789H1.006a.506.506 0 00-.506.506v1.012c0 .28.227.506.506.506h12.83L8.046 15.8a.506.506 0 000 .716z",
  fill: "currentColor"
})));